var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6133_6189",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6133_6189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33268 7.99967V6.66634H10.666V7.99967H5.33268ZM5.33268 5.33301V3.99967H10.666V5.33301H5.33268ZM3.99935 9.33301H8.99935C9.32157 9.33301 9.62157 9.40245 9.89935 9.54134C10.1771 9.68023 10.4105 9.87745 10.5993 10.133L11.9993 11.9663V2.66634H3.99935V9.33301ZM3.99935 13.333H11.366L9.54935 10.9497C9.48268 10.8608 9.40213 10.7913 9.30768 10.7413C9.21324 10.6913 9.11046 10.6663 8.99935 10.6663H3.99935V13.333ZM11.9993 14.6663H3.99935C3.63268 14.6663 3.31879 14.5358 3.05768 14.2747C2.79657 14.0136 2.66602 13.6997 2.66602 13.333V2.66634C2.66602 2.29967 2.79657 1.98579 3.05768 1.72467C3.31879 1.46356 3.63268 1.33301 3.99935 1.33301H11.9993C12.366 1.33301 12.6799 1.46356 12.941 1.72467C13.2021 1.98579 13.3327 2.29967 13.3327 2.66634V13.333C13.3327 13.6997 13.2021 14.0136 12.941 14.2747C12.6799 14.5358 12.366 14.6663 11.9993 14.6663Z",
    fill: "#212121"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.93d2795de893b0a0c6fba6c9977b818d.svg";
export { ForwardRef as ReactComponent };